import { render, staticRenderFns } from "./PaginaInicial.vue?vue&type=template&id=1f8b4c72&scoped=true&lang=pug"
import script from "./PaginaInicial.vue?vue&type=script&lang=js"
export * from "./PaginaInicial.vue?vue&type=script&lang=js"
import style0 from "./PaginaInicial.vue?vue&type=style&index=0&id=1f8b4c72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8b4c72",
  null
  
)

export default component.exports